<template>
  <div class="mit-home-page mit-page">

      <v-container fluid>
          <v-row>
            <v-col cols="12" class="d-flex">
              <v-card class="mit-info-card" style="width:100%">
                  <v-card-title>New Reservation<v-spacer/>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="text-body-2">
                        <span class="red--text font-weight-bold">Note:</span> Building 45 reservations should be done through the <a target="_blank" rel="noopener noreferrer" href="https://spaces.mit.edu">MIT spaces application</a>
                    </span>
                    <span v-else class="text-body-2">
                        <a target="_blank" rel="noopener noreferrer" href="https://spaces.mit.edu">Building 45 Reservations</a>
                    </span>
                    </v-card-title>
                  <v-card-subtitle v-if="$vuetify.breakpoint.smAndUp" class="caption"><a target="_blank" rel="noopener noreferrer" href="https://tig.csail.mit.edu/events-reservations/">Rules and guidelines</a> for reserving a space in building 32. </v-card-subtitle>
                  <v-divider></v-divider>

                  <v-card-text>
                      <MitReserveSchedule :userModel="userModel" :userRoles="userRoles"/>
                  </v-card-text>

              </v-card>
            </v-col>
          </v-row>
      </v-container>
  </div>
</template>

<script>
    import MitReserveSchedule from '../components/MitReserveSchedule.vue';

  export default {
    name: 'MitReservePage',
    components: {
        MitReserveSchedule
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    data: function() {
      return {
      }
    },
    methods: {
    }

  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
